/*
        classCreated: (namespace, classConstructor) =>
        {
            classConstructor.exceptionDetailDialog = new ExceptionDetailDialog();
        }
*/
import { EntityCommand, EntityCommandPropertyValues, EntityCommandTypeEnum, IEntityCommand } from "@seriously-rad/seriouslyrad-framework-core/EntityCommand";
import { EntityCommandInformation } from "@seriously-rad/seriouslyrad-framework-core/EntityCommandInformation";
import { PartialNullable } from "@seriously-rad/seriouslyrad-framework-core/Extensions";
import { ObjectHelper } from "@seriously-rad/seriouslyrad-framework-core/Helpers/ObjectHelper";
import { Property } from "@seriously-rad/seriouslyrad-framework-core/RadObject";
import { GenericEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/GenericEvaluator";
import { PermissionEvaluator } from "@seriously-rad/seriouslyrad-framework-core/Server/DotNet/SeriouslyRAD.Framework.Data.Entities/Evaluation/Evaluators/PermissionEvaluator";
import { WebApiClientService } from "@seriously-rad/seriouslyrad-framework-core/Server/WebApiClientService";
import { ServiceManager } from "@seriously-rad/seriouslyrad-framework-core/ServiceManager";
import { ButtonStyleEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/ButtonStyleEnum";
import { MessageDialog } from "@seriously-rad/seriouslyrad-framework-core/Ui/Controls/MessageDialog";
import { DialogResultEnum } from "@seriously-rad/seriouslyrad-framework-core/Ui/Dialogs/DialogResultEnum";
import { NAMESPACE } from "./_Namespace";

export type EntityCommandProcessInstanceItemTerminateProcessInstancePropertyValues =
    EntityCommandPropertyValues
    & {
    };

export type EntityCommandProcessInstanceItemTerminateProcessInstanceProperties = {
    [name in keyof EntityCommandProcessInstanceItemTerminateProcessInstancePropertyValues]: Property<EntityCommandProcessInstanceItemTerminateProcessInstancePropertyValues[name]>
};

export interface IEntityCommandProcessInstanceItemTerminateProcessInstance extends IEntityCommand, EntityCommandProcessInstanceItemTerminateProcessInstanceProperties
{
}

export class EntityCommandProcessInstanceItemTerminateProcessInstance extends EntityCommand implements IEntityCommandProcessInstanceItemTerminateProcessInstance
{
    // #region Static

    public static override classNamespace = NAMESPACE + "EntityCommandProcessInstanceItemTerminateProcessInstance";
    public static override className = "EntityCommandProcessInstanceItemTerminateProcessInstance";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<EntityCommandProcessInstanceItemTerminateProcessInstancePropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
                description: "Terminate Process Instance",
                entityName: "ProcessInstanceItem",
                key: "TERMINATE_PROCESS_INSTANCE",
                permission: PermissionEvaluator.permissionLevels.update,
                type: EntityCommandTypeEnum.entity,
                visibleEvaluator: new GenericEvaluator({
                    evaluateFn: (_, state) =>
                    {
                        if (!(state instanceof EntityCommandInformation))
                            return false;

                        if (state.record.get()?.statusLookupItem?.description !== "Pending")
                            return false;

                        return true;
                    }
                }),
            }
        };
    }
    public static override getRequiredFields()
    {
        return [
            ...super.getRequiredFields(),
            "statusLookupItem.description",
        ];
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Constructor

    constructor(propertyValues?: PartialNullable<EntityCommandProcessInstanceItemTerminateProcessInstancePropertyValues>)
    {
        super(propertyValues);
    }

    // #endregion

    // #region Overrides

    protected override _executeAsync(entityCommandInformation: EntityCommandInformation, value?: any)
    {
        return (
            super._executeAsync(entityCommandInformation, value)
                .then(() =>
                {
                    const
                        recordId = entityCommandInformation.getRecordId();

                    if (!recordId)
                        return;

                    return (
                        MessageDialog.displayMessage("Terminate Process Instance", "Are you sure you want to terminate the process instance?", ButtonStyleEnum.yesNo)
                            .then(result =>
                            {
                                if (result.dialogResult !== DialogResultEnum.yes)
                                    return;

                                return (
                                    ServiceManager.getRequired(WebApiClientService)
                                        .createApiMethodRequest("DataService", "CallDataService", { id: "b185975f-0e14-4944-b706-6353f0d67dc4", operation: "TerminateProcessInstance", data: ObjectHelper.toJson({ processInstanceItemId: recordId }) })
                                        .executeAsync()
                                );
                            })
                    );
                })
        );
    }

    // #endregion

    // #endregion
}

